module.exports = async function(context) {
  var root = document.getElementById("dashboard-home-root");
  if (!root) return;
  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI || ((((window.UATools || {}).dashboard || {}).api) || null);

  var addButton = document.getElementById("home-add-main");
  var editButton = document.getElementById("home-edit-main");
  var lockedButton = document.getElementById("home-locked-main");

  function getCollectionRoot() {
    return root.querySelector("[data-ua-collection-order='true']");
  }

  function setToggleState(button, enabled, activeClass, inactiveClass, titleOn, titleOff, iconOn, iconOff) {
    if (!button) return;
    var nextLabel = enabled ? titleOn : titleOff;
    var iconNode = button.querySelector("i");
    button.classList.remove(activeClass, inactiveClass);
    button.classList.add(enabled ? activeClass : inactiveClass);
    button.setAttribute("title", nextLabel);
    button.setAttribute("aria-label", nextLabel);
    if (iconNode && (iconOn || iconOff)) {
      var iconName = enabled ? iconOn : iconOff;
      iconNode.className = iconName ? ("bi bi-" + iconName) : "bi bi-lightning";
    }
  }

  function getHeaderState(detail) {
    if (detail && typeof detail === "object") return detail;
    var collectionRoot = getCollectionRoot();
    var state = ((collectionRoot || {}).__uaCollectionOrderState) || {};
    if (collectionRoot && typeof state.showLocked !== "boolean") {
      state.showLocked = collectionRoot.getAttribute("data-collection-show-locked") !== "false";
    }
    return state;
  }

  function syncHeader(detail) {
    var state = getHeaderState(detail);
    setToggleState(
      editButton,
      state.editMode === true,
      "btn-success",
      "btn-outline-secondary",
      "Finish arranging Home",
      "Arrange Home",
      "check2",
      "pencil-square"
    );
    setToggleState(
      lockedButton,
      state.showLocked !== false,
      "btn-success",
      "btn-outline-secondary",
      "Hide team defaults",
      "Show team defaults",
      "eye-slash",
      "eye"
    );
  }

  function scheduleHeaderSync(delayMs) {
    window.setTimeout(function() {
      syncHeader();
    }, Math.max(0, Number(delayMs) || 0));
  }

  if (addButton) {
    addButton.addEventListener("click", function() {
      window.location.href = "/dashboard/platform.dashboards.all";
    });
  }

  if (editButton) {
    editButton.addEventListener("click", function(event) {
      var collectionRoot = getCollectionRoot();
      if (!collectionRoot) return;
      event.preventDefault();
      collectionRoot.dispatchEvent(new CustomEvent("ua:collection:toggle-edit", {
        bubbles: true
      }));
    });
  }

  if (lockedButton) {
    lockedButton.addEventListener("click", function(event) {
      var collectionRoot = getCollectionRoot();
      if (!collectionRoot) return;
      event.preventDefault();
      collectionRoot.dispatchEvent(new CustomEvent("ua:collection:toggle-locked", {
        bubbles: true
      }));
    });
  }

  root.addEventListener("click", async function(event) {
    var button = event.target && event.target.closest ? event.target.closest("[data-collection-action='true']") : null;
    if (!(button) || !root.contains(button)) return;

    var actionName = (button.getAttribute("data-collection-action-name") || "").toString().trim().toLowerCase();
    if (actionName !== "remove-widget" && actionName !== "remove-dashboard") return;
    if (!(dashboardApi)) return;
    if (button.getAttribute("data-home-pin-pending") === "true") return;

    var collectionRoot = getCollectionRoot();
    var state = ((collectionRoot || {}).__uaCollectionOrderState) || {};
    var currentItems = state.directItems instanceof Array ? state.directItems.slice() : [];
    var cardKey = (button.getAttribute("data-collection-card-key") || "").toString().trim();
    if (!(cardKey) || currentItems.length === 0) return;

    var nextItems = currentItems.filter(function(item) {
      return (item.key || "").toString() !== cardKey;
    });
    if (nextItems.length === currentItems.length) return;

    var payload = {};
    try {
      payload = JSON.parse((button.getAttribute("data-collection-action-payload") || "{}").toString());
    } catch (error) {
      payload = {};
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    button.setAttribute("data-home-pin-pending", "true");
    collectionRoot.dispatchEvent(new CustomEvent("ua:collection:load", {
      bubbles: true,
      detail: {
        items: nextItems
      }
    }));

    try {
      var response = await dashboardApi.action("platform.overview", "action", payload);
      if (!(response && response.success)) throw response || new Error("Home pin action failed.");
      collectionRoot.dispatchEvent(new CustomEvent("ua:collection:action-success", {
        bubbles: true,
        detail: {
          action: actionName,
          payload: payload,
          response: response,
          pageNamespace: "platform.overview",
          collectionName: state.name || ""
        }
      }));
    } catch (error) {
      console.error("Home pin toggle failed.", error);
      collectionRoot.dispatchEvent(new CustomEvent("ua:collection:load", {
        bubbles: true,
        detail: {
          items: currentItems
        }
      }));
    } finally {
      button.removeAttribute("data-home-pin-pending");
    }
  }, true);

  root.addEventListener("ua:collection:state-change", function(event) {
    syncHeader((event && event.detail) || {});
  });

  if (window.MutationObserver) {
    var rootObserver = new window.MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i] || {};
        if (mutation.type === "childList") {
          syncHeader();
          return;
        }
        if (
          mutation.type === "attributes"
          && mutation.target
          && mutation.target.getAttribute
          && mutation.target.getAttribute("data-ua-collection-order") === "true"
        ) {
          syncHeader();
          return;
        }
      }
    });

    rootObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-collection-show-locked", "data-collection-edit-mode"]
    });
  }

  syncHeader();
  scheduleHeaderSync(0);
  scheduleHeaderSync(50);
  scheduleHeaderSync(150);
};
